import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  makeStyles,
  Button,
  Box,
  Table,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  TableContainer,
  TextField,
  InputAdornment,
  useTheme,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import AddIcon from "@material-ui/icons/Add";
import { Pagination } from "@material-ui/lab";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import AlertDialog from "../../components/Alert/AlertDialog";
import CreateCategory from "./CreateCategory";
import { useDispatch, useSelector } from "react-redux";
import { deleteCategory, getCategory } from "../../store/action";
import UpdateCategory from "./UpdateCategory";
import Notification from "../../components/Notification/Notification";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import Loading from "../../components/Loading/Loading";
import moment from "moment/moment";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: 'auto',
    padding: 20,
    background: theme.palette.background.main
  },
  container: {
    marginTop: "15px",
    maxHeight: "calc(100vh - 260px)",
  },
}));

const Categories = () => {
  const classes = useStyle();
  const theme = useTheme();
  const { mode } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [Id, setId] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteNotify, SetDeleteNotify] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));

  const [page, setPage] = React.useState(1);
  const [searchData, setSearchData] = useState({ search: "", status: "" });
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");
  const { getCategoryItem, loading, deleteSuccess, deleteError } =
    useSelector((state) => state.candidateCategory);
  const loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

  const handleClickOpen = (id) => {
    setOpen(true);
  };
  const handleUpdateClickOpen = (id) => {
    setOpenUpdate(true);
    setId(id);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenUpdate(false);
  };

  const deleteRoleClose = () => {
    setDeleteOpen(false);
  };

  const alertResponse = (id) => {
    if (disabled === true) {
      dispatch(deleteCategory(id));
    }
    setDisabled(false);
    SetDeleteNotify(true);
  };

  // -----------------------------------
  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(getSpecialitiesData(page, d1), 100);
    } else {
      setTimeout(getSpecialitiesData(page, ""), 100);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleClickSearch = (event, value) => {
    setTimeout(getSpecialitiesData(page, searchData.search), 1000);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    setTimeout(getSpecialitiesData(value), 2000);
  };

  const getSpecialitiesData = (
    pageNo = 1,
    search = "",
    type = order,
    column_name = orderBy
  ) => {
    dispatch(getCategory({ pageNo, search, type, column_name }));
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getSpecialitiesData();
  }, [order, orderBy]);

  const deleteCategoryData = (id) => {
    setId(id);
    setDeleteOpen(true);
    setDisabled(true);
    // dispatch(deleteCategory(id))
  };

  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  return (
    <>
      {loading && <Loading open={loading} />}

      {deleteNotify && deleteSuccess?.message && (
        <Notification data={deleteSuccess?.message} status="success" />
      )}

      {deleteNotify && deleteError?.message && (
        <Notification data={deleteError?.message} status="error" />
      )}

      <Paper className={`${classes.root} mb-6`}>
        <Box className="mb-5" display="flex" justifyContent="space-between" alignItems="center">
          <TextField
            size="small"
            placeholder="Search now..."
            name="search"
            variant="outlined"
            onChange={handleSearchChange}
            onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    style={{
                      color: "#856f6f", // Icon color
                      cursor: "pointer",
                    }}
                    onClick={handleClickSearch}
                  />
                </InputAdornment>
              ),
            }}
            className="modernSearchField"
          />

          {/* {staffDetail !== "Booking" && staffDetail !== "Finance" && ( */}
          {((loginUserInfo?.role === "STAFF" &&
            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "manage-category-create")) || (loginUserInfo?.role !== "STAFF")) && (<div className="ml-5">
              <Button
                variant="contained"
                style={{ textTransform: "capitalize" }}
                color="secondary"
                onClick={handleClickOpen}
              >
                <AddIcon className="mr-2" />
                Add Category
              </Button>
            </div>)}
          {/* )} */}
        </Box>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              rowCount={getCategoryItem?.data?.data?.length}
              headCells={headCells[0]}
            />
            <TableBody>
              {getCategoryItem?.data &&
                getCategoryItem?.data.map((row, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                        {getCategoryItem?.from + index}
                      </TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.name}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row.status == "deactive" ? 'inactive' : 'active'}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{row?.user_name}</TableCell>
                      <TableCell align="left" style={{ color: theme.palette.listItem }}>{moment(row.created_at).format("DD-MMM-YYYY").toUpperCase()}</TableCell>

                      {/* {staffDetail !== "Booking" &&
                        staffDetail !== "Finance" && ( */}
                      <TableCell align="center">
                        <Box
                          display="flex"
                          alignItems="center"
                        // justifyContent="flex-end"
                        >
                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "manage-category-update")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                              onClick={() => handleUpdateClickOpen(row.id)}
                              style={{ padding: 6 }}
                            >
                              <EditIcon color="primary" />
                            </IconButton>)}
                          {((loginUserInfo?.role === "STAFF" &&
                            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "manage-category-delete")) || (loginUserInfo?.role !== "STAFF")) && (<IconButton
                              onClick={() => deleteCategoryData(row.id)}
                              style={{ padding: 6 }}
                            >
                              <DeleteIcon color="secondary" />
                            </IconButton>)}
                        </Box>
                      </TableCell>
                      {/* )} */}
                    </TableRow>
                  );
                })}
              {!getCategoryItem?.data && (
                <TableRow>
                  <TableCell scope="row" colSpan="4" align="center">
                    Sorry, speciality not available!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box className="mt-5" display="flex" justifyContent="flex-end">
          <Pagination
            onChange={handleChangePage}
            page={page}
            count={getCategoryItem?.last_page}
            showFirstButton
            showLastButton
          />
        </Box>
      </Paper>

      <CreateCategory open={open} handleClose={handleClose} />

      <UpdateCategory open={openUpdate} handleClose={handleClose} id={Id} />

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deleteRoleClose}
        response={alertResponse}
        title="Delete Category"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />

    </>
  );
};

export default Categories;
